import React from 'react';
import { translate } from 'react-i18next';

class SidebarDropOfferItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { deeplink_triggered: false };
  }

  handleClick(e) {
    this.props.clickDelegate(this.props.shift);
  }

  componentWillReceiveProps() {
    // trigger the default click behaviour if deeplinked
    if (this.props.deeplinked && !this.state.deeplink_triggered) {
      this.props.clickDelegate(this.props.shift);
      this.setState({
        deeplink_triggered: true,
      });
    }
  }

  render() {
    let { endTime } = this.props;
    if (this.props.hideEnd) endTime = this.props.t('SidebarDropOfferItem.tbd');

    return (
      <li onClick={this.handleClick.bind(this)}>
        {this.props.startTime}
        {' – '}
        {endTime}
        <span className="exchange-details-item">{this.props.label}</span>
      </li>
    );
  }
}

export default translate()(SidebarDropOfferItem);
